<section class="content">
    <div class="card" style="padding: 25px">
        <div class="row">
            <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">{{title}}</div>
        </div>
        
      <!-- <div class="row">
        <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
          {{title}} <br>
          <span style="font-size: 15px;">
            PR3 report gives you entries that exist in both Aavin-Kultivate software and Axis Bank MIS excel. Even though
            we have entries in both systems, the transacted amount may or may not match. The in-page report will list all
            transactions, with amounts mismatched highlighted in RED. 
            <br>
            This report will give you two excel files, <br>
            (1) List of all amount matched entries &nbsp; &nbsp;
            (2) List of all amount mismatched entries</span>
        </div>
      </div> -->
  
      <div class="row">
        <div class="col-2">
          <mat-label>From Date</mat-label>
          <input type="date" [(ngModel)]="from_date" (ngModelChange)="changeEvent()" class="main-border-class" />
        </div>
        <div class="col-2">
          <mat-label>To Date</mat-label>
          <input type="date" [(ngModel)]="to_date" (ngModelChange)="changeEvent()" [min]="from_date"
            class="main-border-class" />
        </div>
        <div class="col-2">
          <mat-label>Customer Type</mat-label>
          <mat-select [(ngModel)]="selected_customer_type" class="main-border-class" (ngModelChange)="changeEvent()">
            <mat-option [value]="selected_customer_type" *ngFor="let selected_customer_type of customer_type_list">{{selected_customer_type}}</mat-option>
          </mat-select>
        </div>
        <div class="col-1">
          <button (click)="getClicked()"
            style="font-size: 27px;margin-top: 10%;border-radius: 5px;background: blanchedalmond;"
            [disabled]="from_date == null || to_date == null">Get</button>
        </div>
        <div *ngIf="!is_document_available" class="col-2">
          <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="60">
          </mat-progress-spinner>
        </div>
        <div class="col-3" *ngIf="document_file !== null">
            <button mat-button class="button-class" (click)="downloadClicked()" style="margin-top:25px"><i
              class="material-icons">
              get_app
            </i>Download Excel </button>
          </div>
      </div>
    </div>
  
  
    <div class="card" *ngIf="document_file !== null">
      <div class="container-fluid" style="margin-top: 1%;">
        <table class="table table-bordered">
          <thead style="text-align: center;">
            <th class="responce_table">Sl.No</th>
            <th class="responce_table">Booth/Customer Code</th>
            <th class="responce_table">Transaction Number</th>
            <th class="responce_table">Request RID</th>
            <th class="responce_table">Amount Paid</th>
            <th class="responce_table">Request Time</th>
            <th class="responce_table">Responce Time</th>
            <th class="bank_table">Settled Date</th>
          </thead>
          <tbody>
            <tr *ngFor="let val of bank_data_list; let data_index=index">
              <td [ngClass]="val['is_carry'] == true ? 'responce_table' : 'amount_difference' ">{{data_index+1}}</td>
              <td [ngClass]="val['is_carry'] == true ? 'responce_table' : 'amount_difference' ">{{val['Customer/Booth Code']}}</td>
              <td [ngClass]="val['is_carry'] == true ? 'responce_table' : 'amount_difference' ">{{val['Transaction Number']}}</td>
              <td [ngClass]="val['is_carry'] == true ? 'responce_table' : 'amount_difference' ">{{val['RID']}}</td>
              <td [ngClass]="val['is_carry'] == true ? 'responce_table' : 'amount_difference' "style="text-align: right;">{{val['Responce Amount']}}</td>
              <td [ngClass]="val['is_carry'] == true ? 'responce_table' : 'amount_difference' ">{{val['Request Time'] | date : 'd/M/y, h:mm a'}}</td>
              <td [ngClass]="val['is_carry'] == true ? 'responce_table' : 'amount_difference' ">{{val['Response Time'] | date : 'd/M/y, h:mm a'}}</td>
              <td [ngClass]="val['is_carry'] == true ? 'bank_table' : 'amount_difference' ">
                  <span *ngIf="val['Settled Date'] != 'NaT' && val['Settled Date'] != 'None' && val['Settled Date'] != null">
                    {{val['Settled Date']| date : 'd/M/y'}}
                  </span>
                </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>